// prettier-ignore
(window as any).global = window;
import { initFederation } from '@angular-architects/native-federation';

// The manifest path is imported from a dedicated file (not from environment.ts)
// because initFederation() MUST run before any shared federation module is loaded.
// environment.ts imports @share_it/foundation-core (a shared module), which would
// break the bootstrap if imported before federation is initialized.
import { federationManifestPath } from './environments/federation-manifest-path';

const FEDERATION_RECOVERY_RELOAD_KEY = 'sit-12664-federation-recovery-reload-attempted';

function reloadOnceAfterFederationFailure(error: unknown): void {
  console.error(error);

  if (sessionStorage.getItem(FEDERATION_RECOVERY_RELOAD_KEY)) {
    return;
  }

  sessionStorage.setItem(FEDERATION_RECOVERY_RELOAD_KEY, new Date().toISOString());
  globalThis.location.reload();
}

initFederation(federationManifestPath)
  .then(() => import('./bootstrap'))
  .catch((error: unknown) => reloadOnceAfterFederationFailure(error));
